{
  "push_channels.runtime.switch": "切换到当前运行环境",
  "push_channels.runtime.mismatch": "当前服务运行于{environment}环境，此配置不能在当前服务发送测试通知。",
  "push_channels.runtime.explanation": "业务环境决定由哪套 API 和 Worker 处理；APNs Sandbox/Production 对应安装包的签名推送环境，两者独立。",
  "push_channels.test.request_id": "请求标识（Request ID）",
  "push_channels.test.apns_environment": "APNs 环境",
  "push_channels.title": "推送渠道",
  "push_channels.description": "按应用和环境管理 APNs、FCM、国内 Android 厂商及 HarmonyOS NEXT 推送。",
  "push_channels.columns.provider": "厂商",
  "push_channels.columns.platform": "平台",
  "push_channels.columns.variant": "构建变体",
  "push_channels.columns.status": "状态",
  "push_channels.columns.credential": "凭据",
  "push_channels.columns.actions": "操作",
  "push_channels.environment.label": "运行环境",
  "push_channels.environment.development": "开发",
  "push_channels.environment.test": "测试",
  "push_channels.environment.staging": "预发布",
  "push_channels.environment.production": "生产",
  "push_channels.provider.apns": "Apple APNs",
  "push_channels.provider.fcm": "Firebase Cloud Messaging",
  "push_channels.provider.huawei_android": "华为 Android",
  "push_channels.provider.honor": "荣耀",
  "push_channels.provider.xiaomi": "小米",
  "push_channels.provider.oppo": "OPPO",
  "push_channels.provider.vivo": "vivo",
  "push_channels.provider.meizu": "魅族",
  "push_channels.provider.harmony": "HarmonyOS Push Kit",
  "push_channels.platform.ios": "iOS",
  "push_channels.platform.android": "Android",
  "push_channels.platform.harmony": "HarmonyOS NEXT",
  "push_channels.variant.ios": "iOS",
  "push_channels.variant.android_google": "Android Google",
  "push_channels.variant.android_china": "Android 国内",
  "push_channels.variant.harmony": "HarmonyOS",
  "push_channels.status.unconfigured": "未配置",
  "push_channels.status.draft": "草稿",
  "push_channels.status.ready": "预检通过",
  "push_channels.status.active": "已启用",
  "push_channels.status.faulted": "故障",
  "push_channels.status.disabled": "已停用",
  "push_channels.actions.configure": "配置",
  "push_channels.actions.rotate_secret": "轮换凭据",
  "push_channels.actions.preflight": "预检",
  "push_channels.actions.activate": "启用",
  "push_channels.actions.disable": "停用",
  "push_channels.actions.test": "测试推送",
  "push_channels.values.configured": "已配置",
  "push_channels.values.missing": "未配置",
  "push_channels.security.title": "敏感凭据仅写入",
  "push_channels.security.description": "私钥、服务账号和厂商 Secret 经服务端加密保存，页面仅显示配置状态和指纹，不会回显明文。",
  "push_channels.editor.title": "配置 {provider}",
  "push_channels.secret.title": "轮换厂商凭据",
  "push_channels.secret.write_only": "保存后不会再次显示这些值；请确认已安全备份原始凭据。",
  "push_channels.test.title": "发送测试通知",
  "push_channels.test.device": "已注册测试设备",
  "push_channels.test.message_title": "通知标题",
  "push_channels.test.body": "通知正文",
  "push_channels.test.default_title": "AppKernia 推送测试",
  "push_channels.test.default_body": "如果你看到这条通知，说明厂商通道已受理测试消息。",
  "push_channels.test.no_device": "该厂商暂无可选的活动注册设备。",
  "push_channels.summary.title": "近期开启与受理概览",
  "push_channels.summary.note": "统计窗口为最近 {days} 天；厂商受理不等同于设备展示。",
  "push_channels.result.accepted": "厂商受理",
  "push_channels.result.failed": "失败",
  "push_channels.result.invalid_token": "Token 失效",
  "push_channels.result.opened": "已打开",
  "push_channels.feedback.validation": "请完整填写所有必填字段。",
  "push_channels.feedback.saved": "推送渠道草稿已保存。",
  "push_channels.feedback.secret_rotated": "凭据已加密替换，请重新执行预检。",
  "push_channels.feedback.preflight": "预检已完成。",
  "push_channels.feedback.activate": "推送渠道已启用。",
  "push_channels.feedback.disable": "推送渠道已停用。",
  "push_channels.feedback.test_queued": "测试通知已进入队列。",
  "push_channels.feedback.load_error": "无法加载推送渠道，请重试。",
  "push_channels.feedback.devices_error": "无法加载已注册测试设备。",
  "push_channels.feedback.error": "操作失败，请检查配置状态或刷新后重试。",
  "push_channels.field.team_id": "Apple Team ID",
  "push_channels.field.key_id": "APNs Key ID",
  "push_channels.field.bundle_id": "Bundle ID",
  "push_channels.field.apns_environment": "APNs 环境",
  "push_channels.field.private_key_p8": "APNs 私钥（.p8）",
  "push_channels.field.project_id": "项目 ID",
  "push_channels.field.package_name": "Android 包名",
  "push_channels.field.service_account_json": "服务账号 JSON",
  "push_channels.field.client_id": "Client ID",
  "push_channels.field.notification_channel_id": "Android 通知渠道 ID",
  "push_channels.field.client_secret": "Client Secret",
  "push_channels.field.app_id": "厂商 App ID",
  "push_channels.field.app_key": "厂商 App Key",
  "push_channels.field.region": "服务区域",
  "push_channels.field.app_secret": "厂商 App Secret",
  "push_channels.field.master_secret": "厂商 Master Secret",
  "push_channels.field.service_category": "服务与安全消息类别（厂商批准值）",
  "push_channels.field.operations_category": "资讯与运营消息类别（厂商批准值）",
  "push_channels.field.bundle_name": "HarmonyOS Bundle Name",
  "push_channels.option.apns_environment.sandbox": "沙箱",
  "push_channels.option.apns_environment.production": "生产",
  "push_channels.option.region.china": "中国",
  "push_channels.option.region.singapore": "新加坡",
  "push_channels.option.region.europe": "欧洲",
  "push_channels.option.region.india": "印度",
  "push_channels.option.region.russia": "俄罗斯",
  "push_channels.guide.trigger": "查看推送渠道申请与对接指引",
  "push_channels.guide.title": "推送渠道申请与对接指引",
  "push_channels.guide.intro": "按厂商依次完成账号认证、应用登记、推送能力开通与凭据获取，再将对应值填写到 AppKernia。秘密字段保存后不会回显。",
  "push_channels.guide.verified": "官方资料核验于 {date}",
  "push_channels.guide.actions.close": "关闭",
  "push_channels.guide.sections.application": "申请与开通步骤",
  "push_channels.guide.sections.fields": "配置字段怎么获取",
  "push_channels.guide.sections.before_save": "保存前检查",
  "push_channels.guide.sections.official_resources": "厂商官方资料",
  "push_channels.guide.provider.apns.summary": "iOS 国内外发行均使用 APNs。推荐使用基于 .p8 私钥的令牌认证，并确保 Topic 与应用 Bundle ID 完全一致。",
  "push_channels.guide.provider.apns.account_type": "Apple Developer Program",
  "push_channels.guide.provider.apns.step.1.title": "登记明确 App ID",
  "push_channels.guide.provider.apns.step.1.description": "在 Certificates, Identifiers & Profiles 中登记与应用 Bundle ID 一致的 Explicit App ID。",
  "push_channels.guide.provider.apns.step.2.title": "启用 Push Notifications",
  "push_channels.guide.provider.apns.step.2.description": "在 App ID 能力中启用 Push Notifications，并确认签名配置包含该能力。",
  "push_channels.guide.provider.apns.step.3.title": "创建 APNs 签名密钥",
  "push_channels.guide.provider.apns.step.3.description": "由有权限的成员创建启用 APNs 的 Key，记录 Key ID，并立即下载仅提供一次的 .p8 文件。",
  "push_channels.guide.provider.apns.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.apns.step.4.description": "从 Membership 获取 Team ID，填写 Bundle ID、环境和私钥，再执行服务端预检。",
  "push_channels.guide.provider.apns.field.team_id": "Apple Developer 账号 Membership 页面中的 Team ID，也是 APNs JWT 的 issuer。",
  "push_channels.guide.provider.apns.field.key_id": "创建 APNs Key 后显示的 Key ID。它必须与上传的 .p8 私钥配套。",
  "push_channels.guide.provider.apns.field.bundle_id": "Explicit App ID 的 Bundle ID；发送时作为 apns-topic，必须与安装包一致。",
  "push_channels.guide.provider.apns.field.apns_environment": "开发调试使用 Sandbox；TestFlight/App Store 生产签名使用 Production。",
  "push_channels.guide.provider.apns.field.private_key_p8": "创建 Key 时下载的 .p8 原文。Apple 只允许下载一次，请先存入获批的秘密管理系统。",
  "push_channels.guide.provider.apns.note": "不要上传 APNs 证书代替 .p8。保存前核对 Team ID、Key ID、Bundle ID 和环境；生产与沙箱设备令牌不可混用。",
  "push_channels.guide.provider.apns.link.account": "打开 Apple Keys 控制台",
  "push_channels.guide.provider.apns.link.create_key": "创建私钥说明",
  "push_channels.guide.provider.apns.link.token_auth": "APNs 令牌连接说明",
  "push_channels.guide.provider.fcm.summary": "Google Play 版 Android 使用 FCM HTTP v1。服务端通过服务账号换取短期 OAuth 2.0 访问令牌。",
  "push_channels.guide.provider.fcm.account_type": "Google / Firebase 项目",
  "push_channels.guide.provider.fcm.step.1.title": "创建 Firebase 项目和 Android 应用",
  "push_channels.guide.provider.fcm.step.1.description": "在 Firebase 控制台添加 Android 应用，包名必须与 android_google 安装包完全一致。",
  "push_channels.guide.provider.fcm.step.2.title": "启用 FCM HTTP v1",
  "push_channels.guide.provider.fcm.step.2.description": "确认项目已启用 Firebase Cloud Messaging API，并记录项目设置中的 Project ID。",
  "push_channels.guide.provider.fcm.step.3.title": "创建服务账号凭据",
  "push_channels.guide.provider.fcm.step.3.description": "创建仅具备发送所需权限的服务账号并下载 JSON 密钥，按组织安全策略保管和轮换。",
  "push_channels.guide.provider.fcm.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.fcm.step.4.description": "填写项目 ID、包名和完整服务账号 JSON，然后验证 OAuth 与 FCM API 可用性。",
  "push_channels.guide.provider.fcm.field.project_id": "Firebase 项目设置中的 Project ID，须与服务账号 JSON 的 project_id 一致。",
  "push_channels.guide.provider.fcm.field.package_name": "Firebase 中登记的 Android package name，须与 Google 变体 applicationId 一致。",
  "push_channels.guide.provider.fcm.field.service_account_json": "包含 client_email 和 private_key 的完整 JSON 密钥，仅写入服务端加密存储。",
  "push_channels.guide.provider.fcm.note": "不要填写旧版 Server key，也不要把服务账号 JSON 放进客户端或代码仓库。保存后执行预检确认 HTTP v1 权限。",
  "push_channels.guide.provider.fcm.link.console": "打开 Firebase 控制台",
  "push_channels.guide.provider.fcm.link.android_setup": "Android 接入说明",
  "push_channels.guide.provider.fcm.link.server_auth": "服务端授权说明",
  "push_channels.guide.provider.huawei_android.summary": "华为 Android 设备使用 HMS Push Kit。应用需在 AppGallery Connect 登记包名和签名指纹并开通 Push Kit。",
  "push_channels.guide.provider.huawei_android.account_type": "已实名认证的华为开发者账号",
  "push_channels.guide.provider.huawei_android.step.1.title": "创建 AGC 项目与应用",
  "push_channels.guide.provider.huawei_android.step.1.description": "在 AppGallery Connect 创建项目和 Android 应用，填写与 China 变体一致的包名。",
  "push_channels.guide.provider.huawei_android.step.2.title": "登记签名并配置数据位置",
  "push_channels.guide.provider.huawei_android.step.2.description": "配置发布证书 SHA-256 指纹和数据处理位置，下载更新后的 agconnect-services.json。",
  "push_channels.guide.provider.huawei_android.step.3.title": "启用 Push Kit",
  "push_channels.guide.provider.huawei_android.step.3.description": "在项目 API 管理中启用 Push Kit，从应用信息页获取 Client ID 和 Client Secret。",
  "push_channels.guide.provider.huawei_android.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.huawei_android.step.4.description": "填写应用信息和客户端通知渠道 ID，预检服务端授权与应用匹配关系。",
  "push_channels.guide.provider.huawei_android.field.client_id": "AppGallery Connect 项目设置 > 常规 > 应用信息中的 Client ID。",
  "push_channels.guide.provider.huawei_android.field.package_name": "AGC 中登记的 Android 包名，须与签名安装包一致。",
  "push_channels.guide.provider.huawei_android.field.notification_channel_id": "客户端创建的 Android Notification Channel ID，不是 AGC 密钥；须与应用代码保持一致。",
  "push_channels.guide.provider.huawei_android.field.client_secret": "应用信息中的 Client Secret，仅写入服务端。",
  "push_channels.guide.provider.huawei_android.note": "包名、SHA-256 指纹或 Client ID/Secret 来自不同应用时会导致鉴权或收不到消息；测试前重新下载客户端配置。",
  "push_channels.guide.provider.huawei_android.link.console": "打开 AppGallery Connect",
  "push_channels.guide.provider.huawei_android.link.configure": "AGC 配置说明",
  "push_channels.guide.provider.huawei_android.link.push_kit": "Push Kit 官方资料",
  "push_channels.guide.provider.honor.summary": "荣耀 Android 推送需在荣耀开发者服务平台完成应用登记、签名校验、协议签署和 Push 能力开通。",
  "push_channels.guide.provider.honor.account_type": "已认证的荣耀开发者账号",
  "push_channels.guide.provider.honor.step.1.title": "登记应用",
  "push_channels.guide.provider.honor.step.1.description": "创建 Android 应用，准确填写包名和发布证书 SHA-256 指纹，并完成相关服务协议。",
  "push_channels.guide.provider.honor.step.2.title": "开通推送服务",
  "push_channels.guide.provider.honor.step.2.description": "在应用服务中启用 Push，按业务场景申请通知分类权益。",
  "push_channels.guide.provider.honor.step.3.title": "获取应用凭据",
  "push_channels.guide.provider.honor.step.3.description": "从应用信息获取 App ID、Client ID 和 Client Secret，并妥善保管 Secret。",
  "push_channels.guide.provider.honor.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.honor.step.4.description": "补充客户端通知渠道 ID，验证荣耀 IAM 授权和服务端下行接口。",
  "push_channels.guide.provider.honor.field.app_id": "荣耀开发者平台为该应用分配的 App ID，用于服务端发送路径。",
  "push_channels.guide.provider.honor.field.client_id": "应用凭据中的 Client ID，用于向荣耀 IAM 获取访问令牌。",
  "push_channels.guide.provider.honor.field.package_name": "平台中登记且与 China 变体一致的 Android 包名。",
  "push_channels.guide.provider.honor.field.notification_channel_id": "客户端创建并使用的 Android Notification Channel ID。",
  "push_channels.guide.provider.honor.field.client_secret": "与 Client ID 配套的 Client Secret，仅写入服务端。",
  "push_channels.guide.provider.honor.note": "确认包名、签名指纹与上线安装包一致；通知分类应按真实业务申请，不能用系统消息分类发送运营内容。",
  "push_channels.guide.provider.honor.link.apply": "应用登记说明",
  "push_channels.guide.provider.honor.link.server_api": "服务端下行接口",
  "push_channels.guide.provider.honor.link.classification": "通知分类说明",
  "push_channels.guide.provider.xiaomi.summary": "小米推送按应用所在数据区域使用不同服务端域名。AppId、AppKey、AppSecret 必须属于同一应用和区域。",
  "push_channels.guide.provider.xiaomi.account_type": "小米开发者账号",
  "push_channels.guide.provider.xiaomi.step.1.title": "创建应用并启用推送",
  "push_channels.guide.provider.xiaomi.step.1.description": "在小米开放平台创建应用，登记与 China 变体一致的包名并开通推送服务。",
  "push_channels.guide.provider.xiaomi.step.2.title": "确认服务区域",
  "push_channels.guide.provider.xiaomi.step.2.description": "依据应用创建时选择的数据区域确定 China、Singapore、Europe、India 或 Russia。",
  "push_channels.guide.provider.xiaomi.step.3.title": "获取应用凭据",
  "push_channels.guide.provider.xiaomi.step.3.description": "从应用推送配置获取 AppId、AppKey 和 AppSecret，三者不得跨应用混用。",
  "push_channels.guide.provider.xiaomi.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.xiaomi.step.4.description": "填写包名、区域和客户端通知渠道 ID，验证所选区域的服务端接口。",
  "push_channels.guide.provider.xiaomi.field.app_id": "小米推送控制台中该应用的 AppId。",
  "push_channels.guide.provider.xiaomi.field.app_key": "与 AppId 配套的 AppKey，供客户端初始化识别应用。",
  "push_channels.guide.provider.xiaomi.field.package_name": "小米平台登记的 Android 包名，须与 China 变体一致。",
  "push_channels.guide.provider.xiaomi.field.region": "应用的数据服务区域；决定服务端 API 域名，保存后不可随意切换。",
  "push_channels.guide.provider.xiaomi.field.notification_channel_id": "Android 8 及以上由客户端创建的通知渠道 ID。",
  "push_channels.guide.provider.xiaomi.field.app_secret": "服务端 REST API 使用的 AppSecret，仅写入服务端。",
  "push_channels.guide.provider.xiaomi.note": "区域选择错误会导致鉴权或 Token 不可用。中国、新加坡、欧洲、印度和俄罗斯必须使用官方列出的对应 API 主机。",
  "push_channels.guide.provider.xiaomi.link.enable": "开通推送说明",
  "push_channels.guide.provider.xiaomi.link.regions": "服务区域与域名",
  "push_channels.guide.provider.xiaomi.link.server_api": "服务端 API 说明",
  "push_channels.guide.provider.oppo.summary": "OPPO PUSH 通常要求企业开发者资质和应用审核。开通后从控制台获取 AppKey 与 MasterSecret。",
  "push_channels.guide.provider.oppo.account_type": "OPPO 企业开发者账号",
  "push_channels.guide.provider.oppo.step.1.title": "完成企业认证并创建应用",
  "push_channels.guide.provider.oppo.step.1.description": "在 OPPO 开放平台完成企业认证，创建与发布包名一致的 Android 应用。",
  "push_channels.guide.provider.oppo.step.2.title": "申请开通 PUSH",
  "push_channels.guide.provider.oppo.step.2.description": "按控制台要求提交应用与推送服务申请，等待审核通过。",
  "push_channels.guide.provider.oppo.step.3.title": "获取服务端凭据",
  "push_channels.guide.provider.oppo.step.3.description": "在推送服务配置中取得 AppKey 和 MasterSecret；通知渠道需由客户端创建并同步。",
  "push_channels.guide.provider.oppo.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.oppo.step.4.description": "填写包名、凭据和通知渠道 ID，验证鉴权与服务状态。",
  "push_channels.guide.provider.oppo.field.app_key": "OPPO 推送应用配置中的 AppKey。",
  "push_channels.guide.provider.oppo.field.package_name": "OPPO 平台登记的 Android 包名，须与 China 变体一致。",
  "push_channels.guide.provider.oppo.field.notification_channel_id": "客户端创建并向 OPPO 推送配置同步使用的通知渠道 ID。",
  "push_channels.guide.provider.oppo.field.master_secret": "服务端鉴权使用的 MasterSecret，仅写入服务端。",
  "push_channels.guide.provider.oppo.note": "MasterSecret 不能放入安装包。生产测试前确认应用审核和 PUSH 权益均已通过，且通知渠道已由客户端创建。",
  "push_channels.guide.provider.oppo.link.client": "客户端接入说明",
  "push_channels.guide.provider.oppo.link.console": "平台配置说明",
  "push_channels.guide.provider.oppo.link.auth": "服务端鉴权说明",
  "push_channels.guide.provider.vivo.summary": "vivo 推送需完成应用审核与服务开通。系统消息和运营消息使用不同 classification，类别值必须来自厂商批准。",
  "push_channels.guide.provider.vivo.account_type": "vivo 开发者账号",
  "push_channels.guide.provider.vivo.step.1.title": "创建并审核应用",
  "push_channels.guide.provider.vivo.step.1.description": "在 vivo 开发者平台创建应用，填写与发布安装包一致的包名并完成必要审核。",
  "push_channels.guide.provider.vivo.step.2.title": "启用并验证 vivo 推送",
  "push_channels.guide.provider.vivo.step.2.description": "开通消息推送，按最新隐私要求在用户同意后再初始化 SDK。",
  "push_channels.guide.provider.vivo.step.3.title": "获取凭据并确认消息分类",
  "push_channels.guide.provider.vivo.step.3.description": "获取 AppID、AppKey、AppSecret，并按真实场景申请系统消息或运营消息类别。",
  "push_channels.guide.provider.vivo.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.vivo.step.4.description": "填写厂商批准的类别大写编码，验证鉴权和分类权限。",
  "push_channels.guide.provider.vivo.field.app_id": "vivo 推送控制台为应用分配的 AppID。",
  "push_channels.guide.provider.vivo.field.app_key": "与 AppID 配套、供客户端识别应用的 AppKey。",
  "push_channels.guide.provider.vivo.field.package_name": "vivo 平台登记的 Android 包名，须与 China 变体一致。",
  "push_channels.guide.provider.vivo.field.service_category": "厂商批准的系统消息类别大写编码，仅当业务场景真实符合时使用；发送 classification=1。",
  "push_channels.guide.provider.vivo.field.operations_category": "厂商批准的运营消息类别大写编码，例如获批的 NEWS 或 CONTENT；发送 classification=0。",
  "push_channels.guide.provider.vivo.field.app_secret": "vivo 服务端鉴权使用的 AppSecret，仅写入服务端。",
  "push_channels.guide.provider.vivo.note": "不要自行猜测类别值。以当前控制台审核结果为准，运营内容不得使用系统消息分类绕过额度或用户退订。",
  "push_channels.guide.provider.vivo.link.product": "消息推送产品页",
  "push_channels.guide.provider.vivo.link.enable": "推送服务开通说明",
  "push_channels.guide.provider.vivo.link.privacy": "隐私合规接入说明",
  "push_channels.guide.provider.meizu.summary": "魅族 Flyme 推送需先完成开发者认证并创建应用，再从推送控制台取得客户端标识和服务端密钥。",
  "push_channels.guide.provider.meizu.account_type": "已认证的 Flyme 开发者账号",
  "push_channels.guide.provider.meizu.step.1.title": "完成开发者认证",
  "push_channels.guide.provider.meizu.step.1.description": "注册并完成 Flyme 开放平台开发者认证。",
  "push_channels.guide.provider.meizu.step.2.title": "创建推送应用",
  "push_channels.guide.provider.meizu.step.2.description": "在消息推送服务中创建应用，登记与 China 变体一致的包名。",
  "push_channels.guide.provider.meizu.step.3.title": "获取应用凭据",
  "push_channels.guide.provider.meizu.step.3.description": "从控制台获取 AppId、AppKey 和仅供服务端使用的 AppSecret。",
  "push_channels.guide.provider.meizu.step.4.title": "接入客户端并预检",
  "push_channels.guide.provider.meizu.step.4.description": "按官方 SDK 获取 PushId，再填写服务端配置并执行预检。",
  "push_channels.guide.provider.meizu.field.app_id": "Flyme 推送控制台分配的 AppId。",
  "push_channels.guide.provider.meizu.field.app_key": "供魅族客户端 SDK 初始化使用的 AppKey。",
  "push_channels.guide.provider.meizu.field.package_name": "Flyme 平台登记的 Android 包名，须与 China 变体一致。",
  "push_channels.guide.provider.meizu.field.app_secret": "服务端调用 Flyme 推送 API 使用的 AppSecret，仅写入服务端。",
  "push_channels.guide.provider.meizu.note": "AppSecret 不得进入客户端。包名和签名变化后应重新核对平台应用及客户端 PushId。",
  "push_channels.guide.provider.meizu.link.platform": "打开 Flyme 开放平台",
  "push_channels.guide.provider.meizu.link.push": "消息推送服务",
  "push_channels.guide.provider.meizu.link.client": "Android SDK 接入文档",
  "push_channels.guide.provider.harmony.summary": "HarmonyOS NEXT 使用 Push Kit 和服务账号短期 JWT。消息分类权益按项目和真实业务场景申请。",
  "push_channels.guide.provider.harmony.account_type": "已认证的华为开发者账号",
  "push_channels.guide.provider.harmony.step.1.title": "创建 HarmonyOS 应用",
  "push_channels.guide.provider.harmony.step.1.description": "在 AppGallery Connect 创建 HarmonyOS 应用，确认项目 ID、Client ID 和 Bundle Name。",
  "push_channels.guide.provider.harmony.step.2.title": "启用 Push Kit",
  "push_channels.guide.provider.harmony.step.2.description": "为应用开通 Push Kit，并按服务与运营场景申请自分类消息权益。",
  "push_channels.guide.provider.harmony.step.3.title": "创建服务账号",
  "push_channels.guide.provider.harmony.step.3.description": "在 API Console 创建具备 Push 权限的服务账号并下载 JSON 凭据，用于生成短期 JWT。",
  "push_channels.guide.provider.harmony.step.4.title": "填写并执行预检",
  "push_channels.guide.provider.harmony.step.4.description": "填写应用标识、获批分类和值完整 JSON，验证服务账号与项目权限。",
  "push_channels.guide.provider.harmony.field.project_id": "AppGallery Connect 中 HarmonyOS 应用所属项目的 Project ID。",
  "push_channels.guide.provider.harmony.field.client_id": "该 HarmonyOS 应用的 Client ID。",
  "push_channels.guide.provider.harmony.field.bundle_name": "HarmonyOS 应用的 Bundle Name，须与签名安装包一致。",
  "push_channels.guide.provider.harmony.field.service_category": "厂商审核通过的服务消息自分类大写编码，须与实际服务场景匹配。",
  "push_channels.guide.provider.harmony.field.operations_category": "厂商允许的运营消息分类大写编码；一般为获批的 MARKETING，以控制台结果为准。",
  "push_channels.guide.provider.harmony.field.service_account_json": "具备 Push 权限的完整服务账号 JSON，仅写入服务端并用于短期 JWT。",
  "push_channels.guide.provider.harmony.note": "类别权益和频控以当前 Push Kit 控制台为准。不要把服务账号 JSON 放入 HAP、日志或代码仓库。",
  "push_channels.guide.provider.harmony.link.jwt": "服务账号 JWT 说明",
  "push_channels.guide.provider.harmony.link.classification": "消息分类权益申请",
  "push_channels.guide.provider.harmony.link.client": "HarmonyOS Push API"
}
